import React, { FC } from 'react'

// Local Components
import BillingInfoTable from '../BillingInfoTable'

// Utils
import { formatPriceShort } from '@sketch/utils'

// Types
import {
  BillingSeatsInfoFragment,
  useDraftBillingSummaryQuery,
} from '@sketch/gql-types'

import config from '@sketch/env-config'

interface ProjectedTotalProps {
  seats: BillingSeatsInfoFragment
  projectedCost?: number
  hasSubscription?: boolean
}

const ProjectedTotal: FC<ProjectedTotalProps> = ({
  projectedCost,
  hasSubscription,
  seats,
}) => {
  const { data: draftBillingSummaryYearlyData } = useDraftBillingSummaryQuery({
    variables: {
      planId: config.standard_plans_ids.yearly,
      seats: seats.currentSeatsTotal,
    },
    skip: hasSubscription,
  })
  const { data: draftBillingSummaryMonthlyData } = useDraftBillingSummaryQuery({
    variables: {
      planId: config.standard_plans_ids.monthly,
      seats: seats.currentSeatsTotal,
    },
    skip: hasSubscription,
  })

  return (
    <BillingInfoTable.Row>
      <BillingInfoTable.HeadingCell>
        Projected Total
      </BillingInfoTable.HeadingCell>
      <BillingInfoTable.Cell>
        <div>
          {hasSubscription ? (
            <strong data-testid="projected-total-amount">
              {formatPriceShort(projectedCost!)}
            </strong>
          ) : (
            <span data-testid="draft-amount">
              <strong>
                {formatPriceShort(
                  draftBillingSummaryYearlyData?.draftBillingSummary
                    .billingCycleAmount!
                )}
              </strong>{' '}
              yearly or{' '}
              <strong>
                {formatPriceShort(
                  draftBillingSummaryMonthlyData?.draftBillingSummary
                    .billingCycleAmount!
                )}
              </strong>{' '}
              monthly
            </span>
          )}
          <br />
          <div>
            {hasSubscription
              ? 'Total excluding tax'
              : 'With a paid subscription you would be charged for the total number of Editor Seats you’re using. Total excluding tax.'}
          </div>
        </div>
      </BillingInfoTable.Cell>
    </BillingInfoTable.Row>
  )
}

export default ProjectedTotal
